module.exports = __webpack_public_path__ + "media/images/icon_nega3-d5000362ea50985718fe8df7ff8acd29.svg";